<template>
  <!-- Mail sender component -->
  <v-dialog scrollable max-width="960" v-model="showMailModale">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <v-btn
          small
          slot="activator"
          @click="startDialogAction()"
          color="amber darken1"
          flat
          v-on="on"
        >
          <v-icon small class="pr-2">mail</v-icon> {{ buttonText }}
        </v-btn>
        <span v-html="modaleTitle" />
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title class="pa-0 pt-2">
        <v-toolbar card tile dense height="36" color="transparent">
          <v-icon small class="pr-2">mail</v-icon>

          <span
            class="body-2"
            v-html="showSettings ? 'Language settings' : modaleTitle"
          />

          <v-spacer></v-spacer>
          <v-btn
            dark
            color="primary"
            depressed
            small
            v-if="!showSettings"
            @click="showSettings = true"
            ><v-icon class="pr-2" small>mdi-cog</v-icon>Templates
            settings</v-btn
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text v-if="!showSettings">
        <v-flex xs12 v-if="emailPDFGenerated">
          <template v-if="mailSent">
            <v-layout
              style="height: 300px"
              column
              align-center
              class="text-xs-center"
            >
              <v-spacer></v-spacer>
              <v-flex class="text-xs-center">
                <v-icon color="success" size="80">mdi-email-check</v-icon>

                <h3 style="color: #555" class="pt-4">Email sent!</h3>
              </v-flex>
            </v-layout>
            <p class="text-xs-right mb-0">
              <v-btn flat color="error" @click.prevent="showMailModale = false">
                <v-icon small class="pr-2">close</v-icon>Close
              </v-btn>
            </p>
          </template>
          <template v-else>
            <v-stepper v-model="selectedMailStep">
              <v-stepper-header>
                <v-stepper-step complete editable step="1"
                  >Prepare Email</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step complete editable edit-icon="mail" step="2"
                  >Email Preview</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step
                  complete
                  editable
                  edit-icon="mdi-file-pdf-box"
                  step="3"
                  >PDF Preview</v-stepper-step
                >
              </v-stepper-header>

              <v-stepper-content step="1">
                <v-alert
                  border="left"
                  colored-border
                  :value="true"
                  outline
                  class="px-4 py-2 mb-4"
                  dense
                  :type="
                    recipientsLanguages.includes(selectedEmailLanguageId)
                      ? 'success'
                      : 'error'
                  "
                >
                  <v-label class="font-weight-bold"
                    ><b
                      >This company only accept mails in the following
                      languages:</b
                    ></v-label
                  >
                  <v-chip
                    class="ma-2 pa-1"
                    color="grey lighten-2"
                    v-for="language in acceptedLanguagesByCompany"
                  >
                    <flag
                      style="
                        font-size: 10px;
                        position: relative;

                        margin-right: 8px;
                      "
                      :iso="language.code == 'EN' ? 'gb' : language.code"
                    />
                    {{ language.name }}
                  </v-chip>
                </v-alert>

                <v-autocomplete
                  :items="languages"
                  item-value="id"
                  item-text="name"
                  v-model="selectedEmailLanguageId"
                  label="Template language"
                  @change="changeLanguage"
                  :error="
                    recipientsLanguages.includes(selectedEmailLanguageId) ==
                    false
                  "
                >
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="grey"
                      >mdi-flag-variant</v-icon
                    >Template Language
                  </template>

                  <template v-slot:selection="data">
                    <flag
                      style="
                        font-size: 10px;
                        position: relative;

                        margin-right: 8px;
                      "
                      :iso="data.item.code == 'EN' ? 'gb' : data.item.code"
                    />
                    {{ data.item.name }}
                  </template>

                  <template v-slot:item="data">
                    <flag
                      style="
                        font-size: 10px;
                        position: relative;

                        margin-right: 8px;
                      "
                      :iso="data.item.code == 'EN' ? 'gb' : data.item.code"
                    />
                    {{ data.item.name }}
                  </template>
                </v-autocomplete>

                <v-combobox
                  :items="recipients"
                  v-model="selectedRecipients"
                  label="Recipients"
                  :multiple="true"
                  chips
                  deletable-chips
                >
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="grey">people</v-icon
                    >Recipients
                  </template>
                </v-combobox>

                <v-text-field label="Subject" v-model="subject">
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="grey">subject</v-icon
                    >Subject
                  </template>
                </v-text-field>
                <v-textarea label="Message" v-model="mailContent">
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="grey">message</v-icon
                    >Message
                  </template>
                </v-textarea>
              </v-stepper-content>
              <v-stepper-content step="2">
                <div
                  v-html="
                    finalMailHtml(subject, mailContent, downloadButtonText)
                  "
                ></div>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-flex xs12>
                  <v-btn
                    @click="generatePDFforEmail()"
                    block
                    depressed
                    dark
                    color="#323639"
                    class="my-0 mb-1"
                    ><v-icon small class="pr-2">mdi-cached</v-icon> Regenerate
                    PDF</v-btn
                  >
                </v-flex>
                <v-flex xs12 style="height: inherit" class="pa-0">
                  <!-- DISPLAY PDF IF ALREADY UPLOADED -->

                  <object
                    v-if="uploadedPdfUrl"
                    :data="uploadedPdfUrl"
                    height="500px"
                    width="100%"
                    type="application/pdf"
                  >
                    <embed
                      :src="
                        'http://docs.google.com/gview?url=' +
                        uploadedPdfUrl +
                        '&embedded=true'
                      "
                    />
                  </object>
                </v-flex>
              </v-stepper-content>
            </v-stepper>

            <p class="text-xs-right mb-0">
              <v-btn flat color="error" @click.prevent="showMailModale = false">
                <v-icon small class="pr-2">close</v-icon>Cancel
              </v-btn>
              <v-btn
                depressed
                color="success"
                @click.prevent="sendEmail"
                :disabled="!selectedRecipients"
              >
                <v-icon small class="pr-2">send</v-icon>Send
              </v-btn>
            </p>
          </template>
        </v-flex>
        <v-flex xs12 v-else>
          <v-layout
            style="height: 300px"
            column
            align-center
            class="text-xs-center"
          >
            <v-spacer></v-spacer>
            <v-flex class="text-xs-center">
              <breeding-rhombus-spinner
                style="margin: auto"
                class="text-xs-center"
                :animation-duration="1000"
                :size="80"
                color="#1976d2"
              />

              <h3 style="color: #555" class="pt-4">
                Please wait during PDF creation.
              </h3>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>

      <v-card-text v-else class="pa-0">
        <!-- <v-subheader class="font-weight-bold">Language settings:</v-subheader> -->

        <v-tabs
          v-model="selectedLanguageSettingsTab"
          color="transparent"
          class="px-3"
          slider-color="primary"
        >
          <v-tab
            v-for="n in languages"
            :key="n.id"
            ripple
            ref="tabs"
            :href="'#' + n.id"
          >
            <flag
              style="
                font-size: 10px;
                position: relative;

                margin-right: 8px;
              "
              :iso="n.code == 'EN' ? 'gb' : n.code"
            />

            {{ n.name }}
          </v-tab>
          <!-- <v-spacer></v-spacer>
          <v-btn
            :disabled="!cansave"
            depressed
            small
            color="success"
            class="white--text"
            ><v-icon small class="pr-2">mdi-content-save</v-icon>Save
            changes</v-btn
          > -->
          <v-tab-item v-for="(n, i) in languages" :key="n.name" :value="n.id">
            <v-card flat>
              <v-card-text class="py-2 px-4">
                <v-layout my-2 align-start>
                  <v-flex xs3>
                    <span style="color: #757575">
                      <v-icon small class="pr-1" color="#757575"
                        >mdi-text-short</v-icon
                      >Mail subject:
                    </span>
                  </v-flex>

                  <v-flex xs9>
                    <v-text-field
                      hide-details
                      solo
                      class="dense-input"
                      background-color="#f4f4f4"
                      flat
                      dense
                      v-model="templateSubjects[n.id]"
                      @input="cansave = true"
                      :loading="loadingTemplates"
                      @change="
                        saveTemplate('subject', n.id, templateSubjects[n.id])
                      "
                    />
                  </v-flex>
                </v-layout>

                <v-layout my-2 align-start>
                  <v-flex xs3>
                    <span style="color: #757575">
                      <v-icon small class="pr-1" color="#757575"
                        >mdi-text-short</v-icon
                      >Mail content:
                    </span>
                  </v-flex>

                  <v-flex xs9>
                    <v-textarea
                      :hint="'Use {{download_button}} to add a direct download button in your template'"
                      solo
                      hide-details
                      class="denseArea noAppendInnerMargin"
                      background-color="#f4f4f4"
                      flat
                      auto-grow
                      dense
                      :ref="'txtArea'+n.id"
                      @input="cansave = true"
                      v-model="templateMailContents[n.id]"
                      :loading="loadingTemplates"
                      @change="
                        saveTemplate(
                          'mailContent',
                          n.id,
                          templateMailContents[n.id]
                        )
                      "
                    >
                      <template slot="append" class="toto">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              style="position: absolute: right: 0; top: 0"
                              class="ma-0"
                              dark
                              v-on="on"
                              small
                              icon
                            >
                              <v-icon color="primary"
                                >mdi-code-braces-box</v-icon
                              >
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-tile
                              v-for="(item, index) in interpolations"
                              :key="index"
                              @click="insertText(item.interpolation,'txtArea'+n.id)"
                            >
                              <v-list-tile-title>{{
                                item.interpolation
                              }}</v-list-tile-title>
                            </v-list-tile>

                            <v-list-tile
                              @click="insertText('{{download_button}}', 'txtArea'+n.id)"
                            >
                              <v-list-tile-title
                                v-html="`{{download_button}}`"
                              ></v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout my-2 align-start>


                  <v-flex xs3>
                    <span style="color: #757575">
                      <v-icon small class="pr-1" color="#757575"
                        >mdi-download</v-icon
                      >Download button:
                    </span>
                  </v-flex>

                  <v-flex xs9>
                    <v-text-field
                      hide-details
                      solo
                      class="dense-input"
                      background-color="#f4f4f4"
                      flat
                      dense
                      @input="cansave = true"
                      v-model="templateDownloadButtonTexts[n.id]"
                      :loading="loadingTemplates"
                      @change="
                        saveTemplate(
                          'downloadButtonText',
                          n.id,
                          templateDownloadButtonTexts[n.id]
                        )
                      "
                    />
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <div class="px-4" v-if="noLanguagesAvailableError == false">
          <v-subheader class="pl-3">Preview:</v-subheader>

          <div
            class=""
            :key="cansave"
            v-html="
              finalMailHtml(
                templateSubjects[selectedLanguageSettingsTab],
                templateMailContents[selectedLanguageSettingsTab],
                templateDownloadButtonTexts[selectedLanguageSettingsTab]
              )
            "
          ></div>
        </div>
      </v-card-text>

      <v-divider v-if="showSettings"></v-divider>
      <v-card-actions class="pa-2" v-if="showSettings">
        <v-btn color="grey lighten-3" depressed @click="showSettings = false"
          ><v-icon small class="pr-2">mdi-arrow-left-thick</v-icon> Close form
          settings</v-btn
        >
        <v-spacer></v-spacer>
        <span class="caption text--lighten-2 pr-4">Form ID: {{ formId }}</span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { BreedingRhombusSpinner } from "epic-spinners";
import ACCOUNTING_STATEMENT_PDF_BLOB from "../../graphql/pdf/accounting_statement_pdf.gql";
import uploader from "../../mixins/uploader";
import CtCMailTemplate from "raw-loader!../../../public/mail_templates/ctc_template/ctc_template.html";
import CtCButtonTemplate from "raw-loader!../../../public/mail_templates/ctc_template/ctc_button_template.html";
import SEND_EMAIL from "../../graphql/steps/send_email.gql";
import { mapGetters } from "vuex";
import SEND_PDF_EMAIL_TEMPLATE_INDEX from "../../graphql/send_pdf_email_templates/index.gql";
import CREATE_SEND_PDF_EMAIL_TEMPLATE from "../../graphql/send_pdf_email_templates/create.gql";
import UPDATE_SEND_PDF_EMAIL_TEMPLATE from "../../graphql/send_pdf_email_templates/update.gql";

export default {
  name: "sendPdfMailModale",
  mixins: [uploader],
  components: {
    BreedingRhombusSpinner,
  },
  props: {
    modaleTitle: {
      type: String,
      default: "Send pdf by email",
      required: false,
    },
    formId: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: "Send pdf by email",
      required: false,
    },
    pdfFileName: {
      type: String,
      default: "pdf",
      required: false,
    },
    pdfBody: {
      type: String,
      required: true,
    },
    recipients: {
      type: Array,
      default: () => [],
      required: false,
    },
    recipientsLanguages: {
      type: Array,
      default: () => [],
      required: false,
    },
    interpolations: {
      type: Array,
      default: () => [],
      required: false,
    },
    pdfBlobGqlFile: {
      required: false,
      default: () => ACCOUNTING_STATEMENT_PDF_BLOB,
    },
    defaultSubject: {
      type: String,
      default: "Document Available",
    },
    defaultMailContent: {
      type: String,
      default:
        "'Dear partner,\n\nPlease find attached a copy of your document.\n{{download_button}}\nBest Regards.'",
    },
    defaultDownloadButtonText: {
      type: String,
      default: "Consult my document",
    },
  },
  computed: {
    ...mapGetters("commonStore", ["languages", "getNameById"]),
    acceptedLanguagesByCompany() {
      return this.languages.filter((l) => {
        return this.recipientsLanguages.includes(l.id);
      });
    },
  },
  data() {
    return {
      showSettings: false,
      selectedLanguageSettingsTab: 0,
      selectedEmailLanguageId: "",
      CtCMailTemplate,
      CtCButtonTemplate,
      showMailModale: false,
      emailPDFGenerated: false,
      mailSent: false,
      selectedMailStep: 1,
      generatingPdf: false,
      uploadedPdfUrl: "",
      sendPdfEmailTemplates: [],
      subject: "",
      mailContent: "",
      downloadButtonText: "",
      templateSubjects: {},
      templateMailContents: {},
      templateDownloadButtonTexts: {},
      cansave: false,
      loadingTemplates: false,
      noLanguagesAvailableError: false,
    };
  },
  methods: {
    insertInterpolation(interpolation) {},
    insertText(text, input_ref) {
      if (!text.length) return;
      const textarea = this.$refs[input_ref][0].$refs.input;
      const sentence = textarea.value;
      const len = sentence.length;
      let pos = textarea.selectionStart;
      if (pos === undefined) {
        pos = 0;
      }
      const before = sentence.substr(0, pos);
      const after = sentence.substr(pos, len);
      this.templateMailContents[this.selectedLanguageSettingsTab] = before + text + after;
      this.cansave = true;
      this.$nextTick().then(() => {
        textarea.focus();
        textarea.setSelectionRange(pos + text.length, pos + text.length);
      });
    },
    startDialogAction() {
      this.showMailModale = true;
      this.mailSent = false;
      this.selectedMailStep = 1;
      this.selectedRecipients = this.recipients.map((r) => r);

      this.generatePDFforEmail();
    },
    generatePDFforEmail() {
      console.log("Generating PDF, please wait..");
      this.emailPDFGenerated = false;
      var self = this;
      self
        .sendQuery(self.pdfBlobGqlFile, {
          body: self.pdfBody.replace("{headline}", self.subject),
        })
        .then((data) => {
          // create blob from pdf
          console.log("Pdf file generation success, starting upload...");
          self.generatingPdf = false;
          var b64pdfstr = data.accounting_statement_pdf;
          var content = b64pdfstr.replace(
            "data:application/pdf;filename=generated.pdf;base64,",
            ""
          );
          var binary = atob(content.replace(/\s/g, ""));
          var len = binary.length;
          var buffer = new ArrayBuffer(len);
          var view = new Uint8Array(buffer);
          for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          var blob = new Blob([view], { type: "application/pdf" });

          let name =
            self.pdfFileName.replace(/[^a-z0-9_-]/gi, "").toLowerCase() +
            "-" +
            this.uuidv4() +
            ".pdf";
          var file = new File([blob], name, {
            lastModified: new Date(0),
            type: "application/pdf",
          });

          var fun = () => {};
          var success = (uri) => {
            this.emailPDFGenerated = true;
            this.uploadedPdfUrl = `${process.env.VUE_APP_S3_BUCKET_URL}/${uri}`;
            console.log("Pdf file upload success:", this.uploadedPdfUrl);
          };
          this.process("uploadedPdf", file, fun, fun, fun, fun, fun, success);
        });
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    finalMailHtml(subject, body, button) {
      // Create Download button html from template file
      let download_button_html = "";
      download_button_html = this.CtCButtonTemplate.replace(
        "{BUTTON_HREF}",
        this.uploadedPdfUrl
      ).replace("{BUTTON_TEXT}", button);
      let finalBody = body
          .replace(/\n/g, "<br>")
          .replaceAll("{{download_button}}", download_button_html);


      this.interpolations.forEach(i => {
        finalBody = finalBody.replaceAll(i.interpolation, i.value)
      })
      return this.mailBeautifier(
        finalBody,
        subject,
        this.CtCMailTemplate
      );
    },
    sendEmail() {
      let tempMail = {
        subject: this.subject,
        attachment_attributes: [],
        cc: "",
        bcc: "",
        recipient: this.selectedRecipients.join("; "),
        body: this.finalMailHtml(
          this.subject,
          this.mailContent,
          this.downloadButtonText
        ),
      };
      tempMail.attachment_attributes.push({
        url: this.uploadedPdfUrl,
        origin: "account_statement",
      });

      this.sendMutation("sent", "email", SEND_EMAIL, tempMail).then(() => {
        this.mailSent = true;
      });
    },
    mailBeautifier(mail_body, mail_subject, mail_template) {
      var exportStr =
        "<html><head> <base href='" +
        (process.env.VUE_APP_STAGE === "production"
          ? "https://www.c-t-capp.com/'>"
          : "http://localhost:8080/'>");

      exportStr +=
        '</head><body><div class="document-editor__editable"><div class="ck ck-reset ck-editor ck-rounded-corners ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred ckeditor_main_container">';
      exportStr += mail_template
        .replace("{{ mail_content }}", mail_body)
        .replace("{{ mail_subject }}", mail_subject);
      exportStr += "</div></div></div></body></html>";

      // CSS INLINER
      var juice = require("juice");

      // MINIMUM CSS REQUIERED TO GET TABLES DISPLAYED PROPERLY
      var additional_css =
        "<style>.table {border-collapse: collapse !important; margin:0px !important;} .ck-content .table {{ margin:0px !important; border-collapse: collapse !important; margin-bottom: 2em !important;margin-top: 2em !important;}.ck-content .table table {{border-collapse: collapse !important; width: 100% !important;border: 1px #bababa solid !important;table-layout: fixed !important;}.ck-content .table table th {background: none !important;color: #747474 !important;}.ck-content .table table td {color: #414141 !important;}.ck-content .table table thead {border-bottom: 1px #bababa solid !important;}.ck-content .table table tbody tr {height: auto !important;}.ck-content .table table tbody tr:first-child {border-top: none !important;}.ck-content .table table th, .ck-content .table table td {min-width: 1em !important;padding: 0.4em !important;padding-top: 0.25em !important;padding-left: 0.6em !important;padding-bottom: 0.25em !important;box-shadow: none !important;font-family: Arial, serif !important;font-size: 10px !important;font-weight: normal !important;font-style: normal !important;text-decoration: none !important;border: none !important;text-align: left !important;}table.v-table thead th {font-weight: 600 !important;}.document-editor .ck-content p {margin-bottom: 0px !important;}.ck-content .table table td p {min-width: 1em !important;padding: 0.4em !important;padding-top: 0.2em !important;padding-bottom: 0.2em !important;box-shadow: none !important;font-family: Arial, serif !important;font-size: 10px !important;font-weight: normal !important;font-style: normal !important;text-decoration: none !important;border: none !important;margin: 0 !important;} #product_loop_table table{{border-collapse: collapse !important; border: none !important;}#product_loop_table table thead {border: 1px #bababa solid !important;}#product_loop_table table tr {border-left: 1px #bababa solid !important;border-right: 1px #bababa solid !important;border-top: 1px #eee solid !important;}#product_loop_table table tr:last-child {border-left: none !important;border-right: none !important;}#product_loop_table table tr:last-child {border-top: 1px #bababa solid !important;}#product_loop_table table tr:last-child #product_loop_table_total {border: 1px #bababa solid !important;width: 100px !important;}#product_loop_table table { table-layout: auto !important;}</style>";
      let juice_options = { extraCss: additional_css, preserveImportant: true };

      return juice(exportStr, juice_options);
    },
    getTemplates() {
      this.loadingTemplates = true;
      this.sendQuery(SEND_PDF_EMAIL_TEMPLATE_INDEX, {
        filter: `reference == '${this.formId}'`,
      })
        .then((data) => {
          this.sendPdfEmailTemplates = data.send_pdf_email_templates;
          console.log("Query get templates:", data);
          this.fillTemplates();
        })
        .finally(() => {
          {
            this.loadingTemplates = false;
          }
        });
    },
    changeLanguage() {
      // Set real email fields:
      this.subject = this.templateSubjects[this.selectedEmailLanguageId];
      this.mailContent =
        this.templateMailContents[this.selectedEmailLanguageId];
      this.downloadButtonText =
        this.templateDownloadButtonTexts[this.selectedEmailLanguageId];
    },
    fillTemplates() {
      //Use first store language by default
      this.selectedEmailLanguageId = this.languages[0].id;

      //Override language is recipients have defined languages and take the first one.
      if (this.recipientsLanguages.length)
        this.selectedEmailLanguageId = this.recipientsLanguages[0];

      // Fill default fields for template settings:
      this.languages.forEach((language) => {
        let _tlp = this.sendPdfEmailTemplates.find(
          (et) => et.language_id == language.id
        );
        this.$set(
          this.templateSubjects,
          language.id,
          _tlp && _tlp.subject ? _tlp.subject : this.defaultSubject
        );
        this.$set(
          this.templateMailContents,
          language.id,
          _tlp && _tlp.body ? _tlp.body : this.defaultMailContent
        );
        this.$set(
          this.templateDownloadButtonTexts,
          language.id,
          _tlp && _tlp.download_button_text
            ? _tlp.download_button_text
            : this.defaultDownloadButtonText
        );
      });

      this.changeLanguage();
    },
    saveTemplate(model, language_id, value) {
      if (!this.cansave) return;
      let _tplObj = this.sendPdfEmailTemplates.find(
        (et) => et.language_id == language_id
      );

      let vars = {
        reference: this.formId,
        languageId: language_id,
        [model]: value,
      };

      let gql = CREATE_SEND_PDF_EMAIL_TEMPLATE;

      if (_tplObj) {
        vars["id"] = _tplObj.id;
        gql = UPDATE_SEND_PDF_EMAIL_TEMPLATE;
      }

      this.sendMutation("no-notif", "email template", gql, vars).finally(() => {
        this.cansave = false;
        this.getTemplates();
      });
    },
  },
  watch: {},
  mounted() {
    if (this.languages.length) {
      this.getTemplates();
      this.selectedLanguageSettingsTab = this.languages[0].id;
    } else this.noLanguagesAvailableError = true;
  },
};
</script>

<style lang="stylus" scoped>
.dense-input >>> .v-input__control {
  min-height: 28px !important;
  height: 28px !important;
  font-size: 14px;
}
</style>
<style >
.denseArea.v-textarea.v-text-field--enclosed.v-text-field--single-line
  textarea {
  margin-top: 0px !important;
}

.noAppendInnerMargin.v-textarea.v-text-field--solo .v-input__append-inner {
  margin-top: 4px;
  position: absolute;
  right: 4px;
}
</style>
